<template>
  <el-row class="container">
    <el-col :span="3">
      <div>
        <el-button type="default" @click="goback" size="mini" class="mb-2" icon="el-icon-arrow-left">返回</el-button>
      </div>
      <el-tree class="filter-tree" highlight-current node-key="routeName" :current-node-key="$route.name" :data="mulu"
               default-expand-all @node-click="handleNodeClick" ref="tree"></el-tree>
    </el-col>
    <el-col :span="21">
      <h1>附件3 现场部分不符合项照片</h1>
      <table>
        <template v-for="item in list">
          <tr :key="item.tp1_url">
            <td>
              <el-image :src=item.tp1_url></el-image>
            </td>
            <td>
              <el-image :src=item.tp2_url>
                <div slot="error" class="image-slot">
                </div>
              </el-image>
            </td>
          </tr>
          <tr :key="item.tp2_url">
            <td>{{ item.tp1_remark }}</td>
            <td>{{ item.tp2_remark }}</td>
          </tr>
        </template>
      </table>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      project_id: '',
      site_id: '',
      site_type: '',
      list: [],
      mulu: [
        {id: 1, label: '附件1', routeName: 'report_zg_fj1'},
        {id: 2, label: '附件2', routeName: 'report_zg_fj2'},
        {id: 3, label: '附件3', routeName: 'report_zg_fj3'},
        {id: 4, label: '意见', routeName: 'report_zg_yj'},
      ]
    }
  },
  methods: {
    goback(){
      this.$router.push({name: `site_${this.$route.params.site_type}_list`, params: this.$route.params})
    },
    async getData() {
      try {
        let res = await this.$Api.post('get_report_tps', {project_id: this.project_id, site_id: this.site_id})
        if (res) {
          this.list = res;
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleNodeClick(data) {
      if (this.$route.name != data.routeName) {
        this.$router.push({
          name:  data.routeName,
          params: {project_id: this.project_id, site_id: this.site_id, site_type: this.site_type}
        })
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.getData()
  }
}
</script>

<style scoped>
.mb-2{
  margin-bottom: 10px;
}
table {
  width: 98%;
}

table tr td h1 {
  font-size: 16px;
}

h1 {
  text-align: center;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: left;
  vertical-align: middle !important;
  font-size: 18px;
}

table tr td {
  word-wrap: break-word;
  white-space: pre-wrap;
  word-break: break-all;
}
.filter-tree {
  margin-right: 10px;
}
::v-deep .el-tree-node__content{
  padding: 10px 0;
}
</style>
